import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from '@mui/material';
import dayjs from 'dayjs';

// Dialog zum Erstellen/Bearbeiten eines Gym-Termins.
function TerminDialog({ open, onClose, editTermin, formData, onFormData, loading, onSave }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ bgcolor: '#1f2937', color: '#e0f2fe' }}>
                {editTermin ? 'Termin bearbeiten' : 'Neuer Gym-Termin'}
            </DialogTitle>
            <DialogContent sx={{ bgcolor: '#1f2937' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        label="Datum"
                        type="date"
                        value={formData.datum}
                        onChange={(e) => onFormData({ ...formData, datum: e.target.value })}
                        fullWidth
                        InputLabelProps={{ shrink: true, sx: { color: '#93c5fd' } }}
                        inputProps={{ min: dayjs().format('YYYY-MM-DD') }}
                        sx={{ input: { color: '#e0f2fe' }, '& .MuiOutlinedInput-root': { borderColor: '#1e3a8a' } }}
                        required
                    />
                    <TextField
                        label="Startzeit"
                        type="time"
                        value={formData.startzeit}
                        onChange={(e) => onFormData({ ...formData, startzeit: e.target.value })}
                        fullWidth
                        InputLabelProps={{ shrink: true, sx: { color: '#93c5fd' } }}
                        sx={{ input: { color: '#e0f2fe' }, '& .MuiOutlinedInput-root': { borderColor: '#1e3a8a' } }}
                        required
                    />
                    <TextField
                        label="Notiz (optional)"
                        value={formData.notiz}
                        onChange={(e) => onFormData({ ...formData, notiz: e.target.value })}
                        fullWidth
                        multiline
                        rows={3}
                        InputLabelProps={{ sx: { color: '#93c5fd' } }}
                        sx={{ textarea: { color: '#e0f2fe' }, '& .MuiOutlinedInput-root': { borderColor: '#1e3a8a' } }}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ bgcolor: '#1f2937' }}>
                <Button
                    onClick={onClose}
                    sx={{ color: '#93c5fd' }}
                >
                    Abbrechen
                </Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    disabled={loading}
                    sx={{
                        background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                        color: '#fff',
                        borderRadius: '16px',
                    }}
                >
                    {loading ? 'Speichern...' : 'Speichern'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default TerminDialog;
